export function getWatermark(str) {
  let can = document.createElement("canvas");
  can.width = 700;
  can.height = 400;
  let cans = can.getContext("2d");
  cans.rotate((-20 * Math.PI) / 180);
  cans.font = "20px Vedana";
  cans.fillStyle = "rgba(200, 200, 200, 0.20)";
  cans.textAlign = "left";
  cans.textBaseline = "Middle";
  cans.fillText(str, can.width / 4, (can.height * 2) / 3);
  return "url(" + can.toDataURL("image/png") + ") left top repeat";
}
